/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import Trix from "trix"
import "@rails/actiontext"
import "controllers"
//import "stylesheets/quote"
//import 'swiper/swiper-bundle.css'

window.Turbo = Turbo

ActiveStorage.start()
Turbo.start()

// Add highlight text attribute to Trix
Trix.config.textAttributes.highlight = {
  tagName: "mark",
  inheritable: true
}

// Add highlight button and Tags dropdown to toolbar
addEventListener("trix-initialize", function(event) {
  const buttonGroup = event.target.toolbarElement.querySelector(".trix-button-group--text-tools")
  const strikeButton = buttonGroup.querySelector('[data-trix-attribute="strike"]')

  if (strikeButton) {
    const highlightButton = document.createElement("button")
    highlightButton.setAttribute("type", "button")
    highlightButton.setAttribute("class", "trix-button trix-button--icon trix-button--icon-highlight")
    highlightButton.setAttribute("data-trix-attribute", "highlight")
    highlightButton.setAttribute("title", "Highlight")
    highlightButton.setAttribute("tabindex", "-1")
    highlightButton.textContent = "Highlight"

    strikeButton.parentNode.insertBefore(highlightButton, strikeButton.nextSibling)
  }

  // Add Tags dropdown after Link button
  const linkButton = buttonGroup.querySelector('[data-trix-attribute="href"]')
  if (linkButton) {
    const tagsDropdown = createTagsDropdown(event.target)
    linkButton.parentNode.insertBefore(tagsDropdown, linkButton.nextSibling)
  }
})

function createTagsDropdown(trixEditor) {
  const container = trixEditor.closest('[data-liquid-tags]')
  const clientFirstName = container?.dataset.clientFirstName || 'Tom'
  const allFirstNames = container?.dataset.allFirstNames || 'Tom, Dick and Harry'

  const details = document.createElement('details')
  details.className = 'trix-tags-dropdown'
  details.innerHTML = `
    <summary title="Insert tag">Tags ▾</summary>
    <div class="trix-tags-menu">
      <button type="button" data-tag="{{ client_first_name }}">
        <code>{{ client_first_name }}</code>
        <span>Lead client's first name ("${clientFirstName}")</span>
      </button>
      <button type="button" data-tag="{{ all_first_names }}">
        <code>{{ all_first_names }}</code>
        <span>All party members ("${allFirstNames}")</span>
      </button>
    </div>
  `

  const menu = details.querySelector('.trix-tags-menu')

  // Position menu when opened
  details.addEventListener('toggle', () => {
    if (details.open) {
      const rect = details.getBoundingClientRect()
      menu.style.left = rect.left + 'px'
      menu.style.top = rect.bottom + 'px'
    }
  })

  details.querySelectorAll('[data-tag]').forEach(btn => {
    btn.addEventListener('click', () => {
      trixEditor.editor.insertString(btn.dataset.tag)
      details.removeAttribute('open')
    })
  })

  return details
}

document.addEventListener("turbo:before-stream-render", function(event) {
  // Add a class to an element we are about to add to the page
  // as defined by its "data-stream-enter-class"
  if (event.target.firstElementChild instanceof HTMLTemplateElement) {
    var enterAnimationClass = event.target.templateContent.firstElementChild.dataset.streamEnterClass
    if (enterAnimationClass) {
      event.target.templateElement.content.firstElementChild.classList.add(enterAnimationClass)
    }
  }

  // Add a class to an element we are about to remove from the page
  // as defined by its "data-stream-exit-class"
  var elementToRemove = document.getElementById(event.target.target)
  var streamExitClass = elementToRemove?.dataset?.streamExitClass
  if (elementToRemove && streamExitClass) {
    // Intercept the removal of the element
    event.preventDefault()
    elementToRemove.classList.add(streamExitClass)
    // Wait for its animation to end before removing the element
    elementToRemove.addEventListener("animationend", function() {
      event.target.performAction()
    })
  }
})

// Open external trix links in new tab
document.addEventListener("DOMContentLoaded", function() {
  var trixLinks = document.querySelectorAll('.trix-content a');
  trixLinks.forEach(function(trixLink) {
    trixLink.addEventListener("click", function(event) {
      var el = event.target

      if (!el.isContentEditable && el.host !== window.location.host) {
        el.setAttribute("target", "_blank")
      }
    }, true)
  })
});

// Maintain scroll position with [data-turbo-preserve-scroll] on links
//
// let scrollTop = 0

// addEventListener("turbo:click", ({ target }) => {
//   if (target.hasAttribute("data-turbo-preserve-scroll")) {
//     scrollTop = document.scrollingElement.scrollTop
//   }
// })

// addEventListener("turbo:render", () => {
//   requestAnimationFrame(() => {
//     if (scrollTop) {
//       document.scrollingElement.scrollTo(0, scrollTop)
//     }

//     scrollTop = 0
//   })
// })
